module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Enquiry & Sales Quotation Details")])], 1), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Client Type"
    },
    model: {
      value: (_vm.clientTypeFilter),
      callback: function($$v) {
        _vm.clientTypeFilter = $$v
      },
      expression: "clientTypeFilter"
    }
  })], 1), _vm._v(" "), (_vm.clientTypeFilter != '2') ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.clientTypeFilter != '1') ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLeadCompList'],
      "id": "leadIdFilter",
      "option-value": "lead_id",
      "option-text": "lead_comp_name",
      "placeholder": "Select Lead Name"
    },
    model: {
      value: (_vm.leadIdFilter),
      callback: function($$v) {
        _vm.leadIdFilter = $$v
      },
      expression: "leadIdFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.clientTypeFilter != '0') ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Sea / Air"
    },
    model: {
      value: (_vm.shipmentTypeFilter),
      callback: function($$v) {
        _vm.shipmentTypeFilter = $$v
      },
      expression: "shipmentTypeFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.clientTypeFilter != '2' && _vm.clientTypeFilter != '1') ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Sea / Air"
    },
    model: {
      value: (_vm.shipmentTypeFilter),
      callback: function($$v) {
        _vm.shipmentTypeFilter = $$v
      },
      expression: "shipmentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.flTypeList,
      "option-value": "flVal",
      "option-text": "flText",
      "placeholder": "Select FCL / LCL"
    },
    model: {
      value: (_vm.fclLclFilter),
      callback: function($$v) {
        _vm.fclLclFilter = $$v
      },
      expression: "fclLclFilter"
    }
  })], 1)], 1)], 1) : _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.flTypeList,
      "option-value": "flVal",
      "option-text": "flText",
      "placeholder": "Select FCL / LCL"
    },
    model: {
      value: (_vm.fclLclFilter),
      callback: function($$v) {
        _vm.fclLclFilter = $$v
      },
      expression: "fclLclFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    model: {
      value: (_vm.transportTypeFilter),
      callback: function($$v) {
        _vm.transportTypeFilter = $$v
      },
      expression: "transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.LPfilter),
      callback: function($$v) {
        _vm.LPfilter = $$v
      },
      expression: "LPfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.containerList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.containerFilter),
      callback: function($$v) {
        _vm.containerFilter = $$v
      },
      expression: "containerFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shippingFilter),
      callback: function($$v) {
        _vm.shippingFilter = $$v
      },
      expression: "shippingFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enquiry",
      "id": "newClientName",
      "name": "newClientName"
    },
    model: {
      value: (_vm.enquiryFilter),
      callback: function($$v) {
        _vm.enquiryFilter = $$v
      },
      expression: "enquiryFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search  Quotation",
      "id": "newClientName",
      "name": "newClientName"
    },
    model: {
      value: (_vm.ffQuoteFilter),
      callback: function($$v) {
        _vm.ffQuoteFilter = $$v
      },
      expression: "ffQuoteFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    model: {
      value: (_vm.PickupLocfilter),
      callback: function($$v) {
        _vm.PickupLocfilter = $$v
      },
      expression: "PickupLocfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    model: {
      value: (_vm.HANDfilter),
      callback: function($$v) {
        _vm.HANDfilter = $$v
      },
      expression: "HANDfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    model: {
      value: (_vm.STUFFfilter),
      callback: function($$v) {
        _vm.STUFFfilter = $$v
      },
      expression: "STUFFfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 justify-content-center"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("Filters")])], 1), _vm._v(" "), _c('b-col', [_c('h5', {
    staticClass: "text-muted pull-right",
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "mainEnquiryId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n              "), _c('md-icon', [_vm._v(_vm._s(row0.item.shipmentType == "1" ? "directions_boat" : "flight_takeoff"))])], 1)]
      }
    }, {
      key: "mainEnquirySeries",
      fn: function(row1) {
        return [_c('b', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewExportFCLConPage(row1.item.mainEnquiryId)
            }
          }
        }, [_vm._v(_vm._s(row1.item.mainEnquirySeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Type : " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ? "Sea" : "Air") + "\n              " + _vm._s(row1.item.transportType) + ") - " + _vm._s(row1.item.containerInfo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Date : " + _vm._s(_vm._f("moment")(row1.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.EmpLoc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised By : " + _vm._s(row1.item.employeeName))]), _vm._v(" "), _c('br'), _vm._v(" "), (
          (row1.item.ccStatus == '0' && row1.item.managerApproveCC == '1') ||
          (row1.item.tptStatus == '0' && row1.item.managerApproveTPT == '1') ||
          (row1.item.ffStatus == '0' && row1.item.managerApproveFF == '1')
        ) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Client Approval Pending")]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && _vm.$sessionsStorage.get('designation') == 'Admin') ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "11px"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info",
            "disabled": _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && _vm.$sessionsStorage.get('designation') == 'Admin' ? false : true
          },
          on: {
            "click": function($event) {
              _vm.EnquiryMultiUpdate(row1.item)
            }
          }
        }, [_c('b', [_vm._v("Add Service")])]) : _vm._e(), _vm._v(" "), ((_vm.$sessionsStorage.get('is_access_multi_update') == '1' || (_vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && _vm.$sessionsStorage.get('designation') == 'Admin'))) ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "11px"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info",
            "disabled": row1.item.jobType.indexOf('TPT') >= 0 ? false : true
          },
          on: {
            "click": function($event) {
              _vm.MultiUpdate(row1.item)
            }
          }
        }, [_c('b', [_vm._v("Multi-Update")])]) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row11) {
        return [_c('b', [_vm._v("\n              " + _vm._s(row11.item.clientName) + "\n              \n              "), _c('br'), _vm._v(" "), (row11.item.clientTypeFilter == '3') ? _c('b-badge', [_vm._v("Overseas Agent")]) : _vm._e()], 1), _vm._v(" "), (row11.item.client_type_status) ? _c('b', [_vm._v("Type : " + _vm._s(row11.item.client_type_status))]) : _vm._e()]
      }
    }, {
      key: "PORlocationId",
      fn: function(row7) {
        return [(
          row7.item.multipleContainerType != '' &&
          row7.item.multipleContainerType != null
        ) ? _c('span', [_vm._v("\n              Container Type : " + _vm._s(row7.item.multipleContainerType) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.shippingLine != '' && row7.item.shippingLine != null) ? _c('span', [_vm._v("\n              Prefered Shipping Line : " + _vm._s(row7.item.shippingLine) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.pickup != '' && row7.item.pickup != null) ? _c('span', [_vm._v("\n              Pickup : " + _vm._s(row7.item.pickup) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.stuffingLoc != '' && row7.item.stuffingLoc != null) ? _c('span', [_vm._v("\n              Stuffing : " + _vm._s(row7.item.stuffingLoc) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.handover != '' && row7.item.handover != null) ? _c('span', [_vm._v("\n              Handover : " + _vm._s(row7.item.handover) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.POR != '' && row7.item.POR != null) ? _c('span', [_vm._v("\n              Place of Receipt : " + _vm._s(row7.item.POR) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.jobType && String(row7.item.jobType).split(',').includes('FF')) ? _c('div', [(row7.item.LP != '' && row7.item.LP != null) ? _c('span', [_vm._v("\n                Load Port : " + _vm._s(row7.item.LP) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row7.item.ApprovedSLine != '' &&
          row7.item.shipmentType == '1' &&
          row7.item.ApprovedSLine != null
        ) ? _c('span', [_vm._v("\n                Approved Shipping Line : " + _vm._s(row7.item.ApprovedSLine) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.POD != '' && row7.item.POD != null) ? _c('span', [_vm._v("\n                Port of Discharge : " + _vm._s(row7.item.POD) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.finalPlace != '' && row7.item.finalPlace != null) ? _c('span', [_vm._v("\n                Final Place of Delivery : " + _vm._s(row7.item.finalPlace) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.departAirport != '' && row7.item.departAirport != null) ? _c('span', [_vm._v("\n                Departure Airport : " + _vm._s(row7.item.departAirport) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row7.item.destiAirport != '' && row7.item.destiAirport != null) ? _c('span', [_vm._v("\n                Destination Airport : " + _vm._s(row7.item.destiAirport) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row7.item.noOfPkg != '' &&
          row7.item.noOfPkg != null &&
          row7.item.noOfPkg != '0'
        ) ? _c('span', [_vm._v("\n                No.of Packages : " + _vm._s(row7.item.noOfPkg) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row7.item.cargoReceived != '' &&
          row7.item.cargoReceived != null &&
          row7.item.cargoReceived != '0'
        ) ? _c('span', [_vm._v("\n                Cargo Received At :\n                " + _vm._s(row7.item.cargoReceived == "1" ? "Airport" : "Warehouse") + "\n                "), _c('br')]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "ffStatus",
      fn: function(row6) {
        return _vm.$sessionsStorage.get('finalPagePermision').split(',').indexOf('Pricing') >= 0 || _vm.$sessionsStorage.get('userLevel') == 1 ?
          [_c('div', [_c('b-button-group', {
            attrs: {
              "id": "hjhjh",
              "vertical": ""
            }
          }, [_c('div', [(String(row6.item.jobType).split(',').indexOf('TPT') >= 0) ? _c('b-button', {
            staticStyle: {
              "width": "195px",
              "margin-bottom": "0.5rem"
            },
            attrs: {
              "size": "sm",
              "variant": row6.item.sendHODApprove != 1 ?
                'outline-danger' :
                'outline-success'
            },
            on: {
              "click": function($event) {
                _vm.goToQuo(row6.item, row6.item.mainEnquiryId)
              }
            }
          }, [(row6.item.sendHODApprove != 1) ? _c('span', [_vm._v("Generate TPT Quotation")]) : _c('span', [_vm._v("View TPT Quotation\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(row6.item.tptQSeries) + "\n                      "), _c('br'), _vm._v(" "), (row6.item.tptExistingQuoteUsed != '0') ? _c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v("Existing Quote Used")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
            staticClass: "error"
          }, [_vm._v(_vm._s(row6.item.tptExpired == 1 ? " (Expired)" : ""))])]) : _vm._e()], 1), _vm._v(" "), _c('div', [(String(row6.item.jobType).split(',').indexOf('FF') >= 0) ? _c('b-button', {
            staticStyle: {
              "width": "195px margin-bottom: 0.5rem"
            },
            attrs: {
              "size": "sm",
              "variant": row6.item.sendHODApproveFF != 1 ?
                'outline-danger' :
                'outline-success'
            },
            on: {
              "click": function($event) {
                _vm.goToFF(row6.item, row6.item.mainEnquiryId)
              }
            }
          }, [(row6.item.sendHODApproveFF != 1) ? _c('span', [_vm._v("Generate FF Quotation")]) : _c('span', [_vm._v("View FF Quotation\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(row6.item.mainFFSeries) + "\n                      "), _c('br'), _vm._v(" "), (row6.item.ffExistingQuoteUsed != '0') ? _c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v("Existing Quote Used")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
            staticClass: "error"
          }, [_vm._v(_vm._s(row6.item.ffExpired == 1 ? " (Expired)" : ""))])]) : _vm._e()], 1), _vm._v(" "), _c('div', [(String(row6.item.jobType).split(',').indexOf('CC') >= 0) ? _c('b-button', {
            staticStyle: {
              "width": "195px",
              "margin-bottom": "0.5rem"
            },
            attrs: {
              "size": "sm",
              "variant": row6.item.sendHODApproveCC != 1 ?
                'outline-danger' :
                'outline-success'
            },
            on: {
              "click": function($event) {
                _vm.goToCC(row6.item, row6.item.mainEnquiryId)
              }
            }
          }, [(row6.item.sendHODApproveCC != 1) ? _c('span', [_vm._v("Generate CC Quotation")]) : _c('span', [_vm._v("View CC Quotation\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(row6.item.ccQSeries) + "\n                      "), _c('br'), _vm._v(" "), (row6.item.ccExistingQuoteUsed != '0') ? _c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v("Existing Quote Used")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
            staticClass: "error"
          }, [_vm._v(_vm._s(row6.item.ccExpired == 1 ? " (Expired)" : ""))])]) : _vm._e()], 1)])], 1)] : undefined
      }
    }, {
      key: "ffquotation_remark",
      fn: function(row8) {
        return [(row8.item.ffquotation_remark != '') ? _c('span', [_vm._v("FF : " + _vm._s(row8.item.ffquotation_remark)), _c('br')]) : _vm._e(), _vm._v(" "), (row8.item.ccquotation_remark != '') ? _c('span', [_vm._v("CC : " + _vm._s(row8.item.ccquotation_remark)), _c('br')]) : _vm._e(), _vm._v(" "), (row8.item.tptquotation_remark != '') ? _c('span', [_vm._v("TPT : " + _vm._s(row8.item.tptquotation_remark)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "tptExpired",
      fn: function(row7) {
        return [_c('div', [(
          row7.item.ffQuoteValidity < _vm.currentDateValid &&
          row7.item.ffQuoteValidity != null
        ) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("FF Quote Expired\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row7.item.ccQuoteValidity < _vm.currentDateValid &&
          row7.item.ccQuoteValidity != null
        ) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("CC Quote Expired\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row7.item.tptQuoteValidity < _vm.currentDateValid &&
          row7.item.tptQuoteValidity != null
        ) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("TPT Quote Expired\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (
          (row7.item.tptQuotationPdf != '' &&
            row7.item.tptQuotationPdf != null &&
            row7.item.sendHODApprove == 1) ||
          (row7.item.ffQuotationPdf != '' &&
            row7.item.ffQuotationPdf != null &&
            row7.item.sendHODApproveFF == 1) ||
          (row7.item.ccQuotationPdf != '' &&
            row7.item.ccQuotationPdf != null &&
            row7.item.sendHODApproveCC == 1)
        ) ? _c('b-dropdown', {
          staticClass: "m-2",
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "variant": "success",
            "size": "sm",
            "text": "Quotation PDF"
          }
        }, [(
          row7.item.tptQuotationPdf != '' &&
          row7.item.tptQuotationPdf != null &&
          row7.item.sendHODApprove == 1
        ) ? _c('b-dropdown-item-button', {
          on: {
            "click": function($event) {
              _vm.Print2(row7.item.tptQuotationPdf)
            }
          }
        }, [_vm._v("TPT Quotation PDF")]) : _vm._e(), _vm._v(" "), (
          row7.item.ffQuotationPdf != '' &&
          row7.item.ffQuotationPdf != null &&
          row7.item.sendHODApproveFF == 1
        ) ? _c('b-dropdown-item-button', {
          on: {
            "click": function($event) {
              _vm.Print(row7.item.ffQuotationPdf)
            }
          }
        }, [_vm._v("FF Quotation PDF")]) : _vm._e(), _vm._v(" "), (
          row7.item.ccQuotationPdf != '' &&
          row7.item.ccQuotationPdf != null &&
          row7.item.sendHODApproveCC == 1
        ) ? _c('b-dropdown-item-button', {
          on: {
            "click": function($event) {
              _vm.Print1(row7.item.ccQuotationPdf)
            }
          }
        }, [_vm._v("CC Quotation PDF")]) : _vm._e(), _vm._v(" "), (
          row7.item.mergeClientQuotationPdf != '' &&
          row7.item.mergeClientQuotationPdf != null
        ) ? _c('b-dropdown-item-button', {
          on: {
            "click": function($event) {
              _vm.PrintConso(row7.item.mergeClientQuotationPdf)
            }
          }
        }, [_vm._v("Consolidated Quote PDF")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (
          (row7.item.tptStatus == 1 && row7.item.tptExpired == 0) ||
          (row7.item.ccStatus == 1 && row7.item.ccExpired == 0) ||
          (row7.item.ffStatus == 1 && row7.item.ffExpired == 0)
        ) ? _c('div', [_c('b-button', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.goToExe(row7.item)
            }
          }
        }, [_vm._v("Proceed To Execution")])], 1) : _vm._e(), _c('br'), _vm._v(" "), _c('div', [_c('b-button', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row7.item)
            }
          }
        }, [_vm._v("Document Upload")])], 1), _vm._v(" "), _c('b-modal', {
          ref: "doc-modal",
          staticClass: "modal-dialog-doc",
          attrs: {
            "size": "xl",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            "title": 'Upload Documents - ' + _vm.documentModalSeries
          }
        }, [_c('h5', {
          staticClass: "pull-right text-muted"
        }, [_vm._v(" " + _vm._s(_vm.documentCount + " Documents") + " ")]), _vm._v(" "), (_vm.documentModalSeries) ? _c('div', {
          staticClass: "table-responsive tableMain"
        }, [_c('table', {
          staticClass: "table table-sm table-bordered"
        }, [_c('tbody', {
          staticStyle: {
            "background": "white"
          }
        }, [_c('tr', [_c('th', {
          attrs: {
            "scope": "col"
          }
        }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
          attrs: {
            "scope": "col"
          }
        }, [_vm._v("Document Name")]), _vm._v(" "), _c('th', {
          attrs: {
            "scope": "col"
          }
        }, [_vm._v("Document Remarks")]), _vm._v(" "), _c('th', {
          attrs: {
            "scope": "col"
          }
        }, [_vm._v("Attach Document")]), _vm._v(" "), _c('th', {
          attrs: {
            "scope": "col"
          }
        }, [_vm._v("Action\n                        "), _c('b-button', {
          staticClass: "ml-3",
          attrs: {
            "id": "show-btn",
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.addPortExpenseArray
          }
        }, [_vm._v("\n                          Add Document "), _c('i', {
          staticClass: "fa fa-plus ml-1",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1)]), _vm._v(" "), _vm._l((_vm.documentModalArr), function(item, idx) {
          return _c('tr', {
            key: idx
          }, [_c('th', {
            attrs: {
              "scope": "row"
            }
          }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_c('b-form-input', {
            attrs: {
              "formatter": _vm.capitalizeAll,
              "name": "docName",
              "id": "docName"
            },
            model: {
              value: (item.doc_name),
              callback: function($$v) {
                _vm.$set(item, "doc_name", $$v)
              },
              expression: "item.doc_name"
            }
          }), _vm._v(" "), (item.doc_name_err) ? _c('span', {
            staticClass: "error"
          }, [_vm._v("\n                          " + _vm._s(item.doc_name_err) + "\n                        ")]) : _vm._e(), _vm._v(" "), (item.doc_created_date) ? _c('span', {
            staticClass: "error"
          }, [_vm._v("\n                          Added on " + _vm._s(item.doc_created_date) + "\n                        ")]) : _vm._e(), _c('br'), _vm._v(" "), (item.createdBy || item.updatedBy) ? _c('span', {
            staticClass: "error"
          }, [_vm._v("\n                          Created/Updated By " + _vm._s(item.createdBy ? item.createdBy : item.updatedBy) + "\n                        ")]) : _vm._e(), _c('br')], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
            attrs: {
              "formatter": _vm.capitalizeAll,
              "id": "remark",
              "name": "remark"
            },
            model: {
              value: (item.doc_remark),
              callback: function($$v) {
                _vm.$set(item, "doc_remark", $$v)
              },
              expression: "item.doc_remark"
            }
          })], 1), _vm._v(" "), _c('td', [_c('Single-Upload', {
            attrs: {
              "index": idx,
              "multiple": false,
              "documentName": 'Enq_Doc-',
              "otherDocName": 'Enq_Doc-',
              "folderName": 'Enq_Doc',
              "accept": '*',
              "state": Boolean(item.doc_url),
              "assign_no": _vm.documentModalSeries,
              "fileAllModuleId": _vm.documentModalEnqId
            },
            model: {
              value: (item.doc_url),
              callback: function($$v) {
                _vm.$set(item, "doc_url", $$v)
              },
              expression: "item.doc_url"
            }
          }), _vm._v(" "), (item.doc_url_err) ? _c('span', {
            staticClass: "error"
          }, [_vm._v("\n                          " + _vm._s(item.doc_url_err) + "\n                        ")]) : _vm._e(), _c('br'), _vm._v(" "), (item.doc_url) ? _c('a', {
            attrs: {
              "href": "javascript:void(0)"
            },
            on: {
              "click": function($event) {
                _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.documentModalSeries.replaceAll('/', '_')) + "/" + (item.doc_url.replaceAll('/', '_'))))
              }
            }
          }, [_vm._v("--View\n                        ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-button', {
            staticClass: "ml-2",
            staticStyle: {
              "font-size": "0.675rem"
            },
            attrs: {
              "disabled": (_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? false : true,
              "id": "show-btn",
              "size": "sm",
              "variant": "danger"
            },
            on: {
              "click": function($event) {
                _vm.removeInvArry(item, idx)
              }
            }
          }, [_vm._v("\n                          Remove Document\n                          "), _c('i', {
            staticClass: "fa fa-minus ml-1",
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)])
        })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.documentModalArr.length > 0) ? _c('b-button', {
          staticClass: "mt-3 pull-left",
          attrs: {
            "variant": "primary",
            "id": "addButtonLoaderSB"
          },
          on: {
            "click": _vm.addDocumentDetail
          }
        }, [_vm._v("\n                Save & Submit\n              ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "md-indeterminate": "",
            "id": "loaderSB"
          }
        }), _vm._v(" "), _c('b-button', {
          staticClass: "mt-3 ml-3 pull-left",
          attrs: {
            "variant": "outline-danger"
          },
          on: {
            "click": _vm.hideDocModal
          }
        }, [_vm._v("\n                Close\n              ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('h5', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "dialogFF",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "id": "myDIV",
      "size": "lg",
      "hide-footer": "",
      "title": "Freight Quotation Form"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', [_c('b-card-text', [_c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapseFFMain"
    },
    model: {
      value: (_vm.collapseFFMainVisible),
      callback: function($$v) {
        _vm.collapseFFMainVisible = $$v
      },
      expression: "collapseFFMainVisible"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ff"
    }
  }, [_c('thead', {
    staticStyle: {
      "background": "black !important"
    }
  }, [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("FF Quotation No.")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Quotation PDF & Execution")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ffTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      style: (index == 0 ? 'color:green' : 'color:red'),
      on: {
        "click": function($event) {
          _vm.getMainFFId(item1.mainffId, 'FF')
        }
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "success"
      }
    }, [_c('b', [_vm._v("Quotation No. :")]), _vm._v("\n                            " + _vm._s(item1.mainFFSeries) + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Till :")]), _vm._v("\n                            " + _vm._s(item1.quotationTill == "1" ? "Handover" : "Sailing") + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Date :")]), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.ffvalidityDate)) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.ffExpireStatus == 1 ? " (Expired)" : ""))])])], 1), _vm._v(" "), _c('td', [_c('b', [_vm._v("Manager Approval :")]), _vm._v("\n                          " + _vm._s(item1.ffStatusManager == "0" ?
      "Pending" :
      item1.ffStatusManager == "1" ?
      "Approved" :
      "Rejected") + "\n                          "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Approval :")]), _vm._v("\n                          " + _vm._s(item1.ffClientStatus == "0" ?
      "Pending" :
      item1.ffClientStatus == "1" ?
      "Approved" :
      "Rejected") + "\n                        ")]), _vm._v(" "), (
      index == '0' &&
      item1.ffClientStatus != '2' &&
      item1.ffClientStatus != '1'
    ) ? _c('td', [(
      item1.ffStatusManager != '1' &&
      item1.sendHODApproveFF == '1'
    ) ? _c('b', [_vm._v("Sent For Approval\n                            "), _c('br')]) : (
      item1.ffStatusManager == '1' &&
      item1.sendToEnquiryFF == '0'
    ) ? _c('b', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.openPop(item1)
        }
      }
    }, [_vm._v("Send To Enquiry Team\n                            "), _c('br')]) : (
      item1.ffStatusManager == '1' &&
      item1.sendToEnquiryFF == '1'
    ) ? _c('b', [_vm._v("Already Sent to Enquiry\n                            "), _c('br')]) : _c('b', [_vm._v("N/A\n                            "), _c('br')])]) : _c('td', [_c('b', [_vm._v("\n                            " + _vm._s(item1.ffClientStatus == "2" && index == 0 ?
      "Client Rejected" :
      item1.ffClientStatus == "1" && index == 0 ?
      "Client Approved" :
      "N/A") + "\n                            "), _c('br')])]), _vm._v(" "), _c('td', [(
      item1.ffQuotationPdf != '' && item1.ffQuotationPdf != null
    ) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item1.ffQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")])], 1)])
  }))])])])], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapseFFChild"
    },
    model: {
      value: (_vm.collapseFFChildVisible),
      callback: function($$v) {
        _vm.collapseFFChildVisible = $$v
      },
      expression: "collapseFFChildVisible"
    }
  }, [_c('div', [_c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Quotation Validity Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "validityDate",
      "name": "validityDate"
    },
    model: {
      value: (_vm.mainModal.ffvalidityDate),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "ffvalidityDate", $$v)
      },
      expression: "mainModal.ffvalidityDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Quotation Validity Till")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.qTillList,
      "option-value": "qV",
      "option-text": "qT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.mainModal.quotationTill),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "quotationTill", $$v)
      },
      expression: "mainModal.quotationTill"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.mainModal.sendHODApproveFF == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Manager Approval")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.mainModal.ffStatusManager),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "ffStatusManager", $$v)
      },
      expression: "mainModal.ffStatusManager"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mainModal.sendHODApproveFF == '1') ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "22px"
    },
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoaderM",
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.addGenerateQuotation('5')
      }
    }
  }, [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderM"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [(_vm.ffShipArry.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.visibleMFF = !_vm.visibleMFF
      }
    }
  }, [(_vm.visibleMFF == true) ? _c('span', [_vm._v("Close")]) : _c('span', [_vm._v("New Entry")])]), _vm._v(" "), (
    _vm.mainModal.mainffId != '' &&
    _vm.mainModal.ffStatusManager != '1' &&
    _vm.mainModal.ffClientStatus != '2' &&
    _vm.mainModal.sendHODApproveFF != '1'
  ) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPop
    }
  }, [_vm._v("Send For Aproval\n                      "), _c('md-icon', {
    attrs: {
      "icon": "envelope"
    }
  }, [_vm._v("email")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapseMiddle"
    },
    model: {
      value: (_vm.visibleMFF),
      callback: function($$v) {
        _vm.visibleMFF = $$v
      },
      expression: "visibleMFF"
    }
  }, [(_vm.ffShipArry.length > 0) ? _c('div', {
    staticClass: "gutr"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Shipping Line")]), _vm._v(" "), _c('th', [_vm._v("Client Approval")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ffShipArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item1.shippingLine))]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(item1.ffClientStatus == "" ?
      "Pending" :
      item1.ffClientStatus == "1" ?
      "Approved" :
      "-") + "\n                              ")]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": item1.ffClientStatus == '2'
      },
      on: {
        "click": function($event) {
          _vm.editShip(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1)])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', [(
    _vm.ffShipArry.length < 3 || _vm.shipModal.ffShippingWiseId != ''
  ) ? _c('div', [_c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.shipModal.ffShippingWiseId != '',
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shipModal.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.shipModal, "shippingId", $$v)
      },
      expression: "shipModal.shippingId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Transit Time (No.of Days)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transitTime",
      "name": "transitTime",
      "type": "number"
    },
    model: {
      value: (_vm.shipModal.transitTime),
      callback: function($$v) {
        _vm.$set(_vm.shipModal, "transitTime", $$v)
      },
      expression: "shipModal.transitTime"
    }
  })], 1), _vm._v(" "), (_vm.shipModal.ffShippingWiseId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "22px"
    },
    attrs: {
      "size": "sm",
      "variant": "info",
      "disbaled": _vm.ffShipArry.length < 3 ? false : true
    },
    on: {
      "click": _vm.clearShip
    }
  }, [_vm._v("Clear")])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ffModal.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "containerTypeId", $$v)
      },
      expression: "ffModal.containerTypeId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ledgerData,
      "option-value": "ledger",
      "option-text": "ledger",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ffModal.ffType),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "ffType", $$v)
      },
      expression: "ffModal.ffType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.particularStatus),
      callback: function($$v) {
        _vm.particularStatus = $$v
      },
      expression: "particularStatus"
    }
  }, [_vm._v("Charges As Per Receipt")])], 1), _vm._v(" "), (_vm.particularStatus == '0') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "buyingRate"
    }
  }, [_vm._v("Buying Rate")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingRate",
      "name": "buyingRate",
      "type": "number"
    },
    model: {
      value: (_vm.ffModal.buyingRate),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "buyingRate", $$v)
      },
      expression: "ffModal.buyingRate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Selling Rate")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate",
      "type": "number"
    },
    model: {
      value: (_vm.ffModal.ffSellingRate),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "ffSellingRate", $$v)
      },
      expression: "ffModal.ffSellingRate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.currencyList,
      "option-value": "currencyV",
      "option-text": "currencyT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffModal.currency),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "currency", $$v)
      },
      expression: "ffModal.currency"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1",
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.addGenerateQuotation('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffModal.ffQId == "" ? "Add" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)]) : _vm._e()])])])], 1), _vm._v(" "), (_vm.tempffTableArry.length > 0) ? _c('div', {
    staticClass: "box-body gutr"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Shipping Line")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("FF Type")]), _vm._v(" "), _c('th', [_vm._v("Buying Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), (_vm.shipModal.shippingId != '') ? _c('th', [_vm._v("Action")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipModal.shippingId == ''), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.shippingLine))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ffType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.buyingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ffSellingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), (_vm.shipModal.shippingId != '') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": item1.ffClientStatus == '2'
      },
      on: {
        "click": function($event) {
          _vm.editFF(item1, index)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteTPT(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }))])]) : _vm._e()])])], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialogAlertFF
    }
  }, [_vm._v("Cancel")])], 1)])], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "dialogTPT",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "id": "myDIV1",
      "size": "lg",
      "hide-footer": "",
      "title": "Transport Quotation Form"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', [_c('b-card-text', [_c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapseFFMain2"
    },
    model: {
      value: (_vm.collapseFFMainVisibleTPT),
      callback: function($$v) {
        _vm.collapseFFMainVisibleTPT = $$v
      },
      expression: "collapseFFMainVisibleTPT"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("TPT Quotation")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tptTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      style: (index == 0 ? 'color:green' : 'color:red'),
      on: {
        "click": function($event) {
          _vm.getMainTPTId(item1.tptQId, 'TPT')
        }
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "success"
      }
    }, [_c('b', [_vm._v("Quotation No. :")]), _vm._v("\n                            " + _vm._s(item1.tptQSeries) + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Date :")]), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.validityDate)) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.expireStatus == 1 ? " (Expired)" : ""))])])], 1), _vm._v(" "), _c('td', [_c('b', [_vm._v("Manager Approval :")]), _vm._v("\n                          " + _vm._s(item1.tptStatus == "0" ?
      "Pending" :
      item1.tptStatus == "1" ?
      "Approved" :
      "Rejected") + "\n                          "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Approval :")]), _vm._v("\n                          " + _vm._s(item1.tptClientStatus == "0" ?
      "Pending" :
      item1.tptClientStatus == "1" ?
      "Approved" :
      "Rejected") + "\n                        ")]), _vm._v(" "), (
      index == '0' &&
      item1.tptClientStatus != '2' &&
      item1.tptClientStatus != '1'
    ) ? _c('td', [(item1.tptStatus != '1' && item1.sendHODApprove == '1') ? _c('b', [_vm._v("Sent For Approval\n                            "), _c('br')]) : (
      item1.tptStatus == '1' && item1.sentToEnquiry == '0'
    ) ? _c('b', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.openPop(item1)
        }
      }
    }, [_vm._v("Send To Enquiry Team\n                            "), _c('br')]) : (
      item1.tptStatus == '1' && item1.sentToEnquiry == '1'
    ) ? _c('b', [_vm._v("Already Sent to Enquiry Team\n                            "), _c('br')]) : _c('b', [_vm._v("N/A\n                            "), _c('br')])]) : _c('td', [_c('b', [_vm._v("\n                            " + _vm._s(item1.tptClientStatus == "2" && index == 0 ?
      "Client Rejected" :
      item1.tptClientStatus == "1" && index == 0 ?
      "Client Approved" :
      "N/A") + "\n                            "), _c('br')])]), _vm._v(" "), _c('td', [(
      item1.tptQuotationPdf != '' &&
      item1.tptQuotationPdf != null
    ) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item1.tptQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")])], 1)])
  }))])])])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapseFFChild2"
    },
    model: {
      value: (_vm.collapseFFChildVisibleTPT),
      callback: function($$v) {
        _vm.collapseFFChildVisibleTPT = $$v
      },
      expression: "collapseFFChildVisibleTPT"
    }
  }, [_c('div', [_c('div', [_c('div', [_c('div', [_c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Quotation Validity Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "validityDate",
      "name": "validityDate",
      "not-before": new Date()
    },
    model: {
      value: (_vm.tptModal.validityDate),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "validityDate", $$v)
      },
      expression: "tptModal.validityDate"
    }
  }), _vm._v(" "), (!_vm.tptModal.validityDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.validityDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "distance"
    }
  }, [_vm._v("Distance (Km)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.distance),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "distance", $$v)
      },
      expression: "tptModal.distance"
    }
  }), _vm._v(" "), (!_vm.tptModal.distance) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.distance))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "dieselRate"
    }
  }, [_vm._v("Diesel Allocated (Ltrs)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dieselRate",
      "name": "dieselRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.dieselAllocated),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "dieselAllocated", $$v)
      },
      expression: "tptModal.dieselAllocated"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "dieselRate"
    }
  }, [_vm._v("Diesel Rate (INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dieselRate",
      "name": "dieselRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.dieselRate),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "dieselRate", $$v)
      },
      expression: "tptModal.dieselRate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "mileage"
    }
  }, [_vm._v("Mileage")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mileage",
      "name": "mileage",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.mileage),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "mileage", $$v)
      },
      expression: "tptModal.mileage"
    }
  }), _vm._v(" "), (!_vm.tptModal.mileage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.mileage))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "toll"
    }
  }, [_vm._v("Toll (INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "toll",
      "name": "toll",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.toll),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "toll", $$v)
      },
      expression: "tptModal.toll"
    }
  }), _vm._v(" "), (!_vm.tptModal.toll) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.toll))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "margin"
    }
  }, [_vm._v("Advance Cash INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "margin",
      "name": "margin",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.advanceCash),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "advanceCash", $$v)
      },
      expression: "tptModal.advanceCash"
    }
  }), _vm._v(" "), (!_vm.tptModal.advanceCash) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.advanceCash))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "baseCost"
    }
  }, [_vm._v("Base Cost (INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "baseCost",
      "name": "baseCost",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.baseCost),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "baseCost", $$v)
      },
      expression: "tptModal.baseCost"
    }
  }), _vm._v(" "), (!_vm.tptModal.baseCost) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.baseCost))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "quoRate"
    }
  }, [_vm._v("Transportation Charges ( INR )")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "quoRate",
      "name": "quoRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptModal.quotRate),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "quotRate", $$v)
      },
      expression: "tptModal.quotRate"
    }
  }), _vm._v(" "), (!_vm.tptModal.quotRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.quotRate))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.tptModal.tptQId != '' && _vm.tptModal.sendHODApprove == '1') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Quotation Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.tptModal.tptStatus),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "tptStatus", $$v)
      },
      expression: "tptModal.tptStatus"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "quoRate"
    }
  }, [_vm._v("Remarks if Any")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "quoRate",
      "name": "quoRate"
    },
    model: {
      value: (_vm.tptModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "remark", $$v)
      },
      expression: "tptModal.remark"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoaderAdd",
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.addMainTpt('5')
      }
    }
  }, [_vm._v(_vm._s(_vm.tptModal.tptQId == "" ? "Add" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderAdd"
    }
  })], 1)], 1), _vm._v(" "), (_vm.tptTableArryChild.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.visibleMTPT = !_vm.visibleMTPT
      }
    }
  }, [(_vm.visibleMTPT == true) ? _c('span', [_vm._v("Close")]) : _c('span', [_vm._v("New Entry")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), (
    _vm.tptModal.tptQId != '' &&
    _vm.tptModal.tptStatus != '1' &&
    _vm.tptModal.tptClientStatus != '2'
  ) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPop
    }
  }, [_vm._v("Send For Aproval\n                          "), _c('md-icon', {
    attrs: {
      "icon": "envelope"
    }
  }, [_vm._v("email")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapseMiddle"
    },
    model: {
      value: (_vm.visibleMTPT),
      callback: function($$v) {
        _vm.visibleMTPT = $$v
      },
      expression: "visibleMTPT"
    }
  }, [(_vm.tptModal.tptQId != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.tptTableModal.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "containerTypeId", $$v)
      },
      expression: "tptTableModal.containerTypeId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tptModal.tptQId != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Other Charges")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ledgerData,
      "option-value": "ledger",
      "option-text": "ledger",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.tptTableModal.otherCharge),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "otherCharge", $$v)
      },
      expression: "tptTableModal.otherCharge"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.otherCharge) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptTableModal.otherCharge))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Currency")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.currencyList,
      "option-value": "currencyV",
      "option-text": "currencyT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.tptTableModal.currency),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "currency", $$v)
      },
      expression: "tptTableModal.currency"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Buy In Rate")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.byInPrice),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "byInPrice", $$v)
      },
      expression: "tptTableModal.byInPrice"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.byInPrice) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptTableModal.byInPrice))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "buyingRate"
    }
  }, [_vm._v("Selling Rate")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingRate",
      "name": "buyingRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.qRate),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "qRate", $$v)
      },
      expression: "tptTableModal.qRate"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.qRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptTableModal.qRate))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tptModal.tptQId != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "freeDays"
    }
  }, [_vm._v("Free Days")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "freeDays",
      "name": "freeDays",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.freeDays),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "freeDays", $$v)
      },
      expression: "tptTableModal.freeDays"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate"
    },
    model: {
      value: (_vm.tptTableModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "remark", $$v)
      },
      expression: "tptTableModal.remark"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.remark) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptTableModal.remark))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.tptModal.tptQId != '') ? _c('b-button', {
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderOth",
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.addMainTpt('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.tptTableModal.tptTableId == "" ? "Add" : "Update"))]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderOth"
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.tptTableArryChild.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Other Charges")]), _vm._v(" "), _c('th', [_vm._v("Buy In Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Remarks")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tptTableArryChild), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.otherCharge))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.byInPrice) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.qRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.remark))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.editTPTChild(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteTPTOg(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }))])])]) : _vm._e()])])])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialogAlertFF
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "EnquiryMultiUpdate-modal",
    attrs: {
      "id": "EnquiryMultiUpdate-modal",
      "title": ("Change Job Type - Enq No - " + _vm.mu_enq_series + " Job Type - (" + (_vm.multiUpdateDetail.jobType) + ")"),
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientType"
    }
  }, [_vm._v("Change Client Type")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.clientTypeUpdateList,
      "id": "clientType",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Change Client Type"
    },
    model: {
      value: (_vm.clientType),
      callback: function($$v) {
        _vm.clientType = $$v
      },
      expression: "clientType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mt-3",
    attrs: {
      "label": "Select Job Types"
    }
  }, [_vm._l((_vm.NewshowSegmentArray), function(segmentNameArray, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-2",
      attrs: {
        "md-flex": segmentNameArray.flex,
        "md-flex-small": "100"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1),
        "disabled": segmentNameArray.disabled
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index, !segmentNameArray.checked)
        }
      },
      model: {
        value: (segmentNameArray.checked),
        callback: function($$v) {
          _vm.$set(segmentNameArray, "checked", $$v)
        },
        expression: "segmentNameArray.checked"
      }
    }, [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(segmentNameArray.value))])], 1), _vm._v(" "), (_vm.newJobType.length <= 0) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n                " + _vm._s(_vm.multiUpdateDetail.JobTypeError) + "\n              ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.multiUpdateDetail.jobType && _vm.multiUpdateDetail.jobType.length === 0) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.multiUpdateDetail.JobTypeError) + "\n            ")]) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.minusJob.indexOf('TPT') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('TPT') && !_vm.multiUpdateDetail.oldpickupLocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("TPT") >= 0 ? "Pickup Location *" : "Pickup Location"))]), _vm._v(" "), (_vm.multiUpdateDetail.shipmentType == '1' && _vm.multiUpdateDetail.transportType == 'Export' && _vm.multiUpdateDetail.multipleContainerType.includes('LCL Container') && _vm.minusJob.indexOf('TPT') >= 0) ? _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.multiUpdateDetail.shipmentType == '1' &&
        _vm.multiUpdateDetail.transportType == 'Export' &&
        _vm.multiUpdateDetail.multipleContainerType.includes('LCL Container') &&
        _vm.minusJob.indexOf('TPT') >= 0 ?
        true :
        false,
      "id": "down2",
      "list": _vm.getAlllocationListDataFactory,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": _vm.allLocationList.length > 0 ?
        'Select Pickup Location' :
        'No Pickup Location'
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "pickupLocationId", $$v)
      },
      expression: "multiUpdateDetail.pickupLocationId"
    }
  }) : (_vm.multiUpdateDetail.shipmentType == '1') ? _c('model-list-select', {
    attrs: {
      "list": _vm.allLocationList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'getAlllocationListData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'getAlllocationListData'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "pickupLocationId", $$v)
      },
      expression: "multiUpdateDetail.pickupLocationId"
    }
  }) : _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transporterName",
      "name": "transporterName"
    },
    model: {
      value: (_vm.multiUpdateDetail.airPickup),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airPickup", $$v)
      },
      expression: "multiUpdateDetail.airPickup"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.pickupLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.pickupLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('TPT') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('TPT') && !_vm.multiUpdateDetail.oldhandoverLocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("TPT") >= 0 ? "Handover Location *" : "Handover Location"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "list": _vm.handoverListData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'handoverListData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'handoverListData'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.handoverLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "handoverLocationId", $$v)
      },
      expression: "multiUpdateDetail.handoverLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.handoverLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.handoverLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('TPT') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('TPT') && !_vm.multiUpdateDetail.oldstuffingLocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("TPT") >= 0 ? "Factory Location *" : "Factory Location"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Factory Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
        _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' &&
          _vm.multiUpdateDetail.multipleContainerType.includes('LCL Container') &&
          _vm.minusJob.indexOf('TPT') >= 0 ?
          _vm.FactoryPickupSame(_vm.multiUpdateDetail.stuffingLocationId) :
          '';
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.stuffingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "stuffingLocationId", $$v)
      },
      expression: "multiUpdateDetail.stuffingLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.stuffingLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.stuffingLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('FF') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('FF') && !_vm.multiUpdateDetail.oldcontainerInfo) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffAc"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("CC") >= 0 || _vm.minusJob.indexOf("FF") >= 0 ? "FF Activity Type *" : "FF Activity Type"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.multiUpdateDetail.shipmentType == '1' ? _vm.containerInfoName : _vm.ffActivityAir,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Activity Type"
    },
    model: {
      value: (_vm.multiUpdateDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "containerInfo", $$v)
      },
      expression: "multiUpdateDetail.containerInfo"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.containerInfoError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('FF') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('FF') && !_vm.multiUpdateDetail.oldstuffingType) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffAc"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("CC") >= 0 || _vm.minusJob.indexOf("FF") >= 0 ? "Stuffing Type *" : "Stuffing Type"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeName,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Stuffing Type"
    },
    model: {
      value: (_vm.multiUpdateDetail.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "stuffingType", $$v)
      },
      expression: "multiUpdateDetail.stuffingType"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.stuffingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.stuffingTypeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('FF') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('FF') && !_vm.multiUpdateDetail.oldimporterClientId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffssd"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("CC") >= 0 || _vm.minusJob.indexOf("FF") >= 0 ? "Importer Name *" : "Importer Name"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.multiUpdateDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "importerClientId", $$v)
      },
      expression: "multiUpdateDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.importerClientIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('FF') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('FF') && !_vm.multiUpdateDetail.oldPODLocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("FF") >= 0 ? "Port of Discharge *" : "Port of Discharge"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Sea_Port_India',
          'getPortDischargeList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'getPortDischargeList'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "PODLocationId", $$v)
      },
      expression: "multiUpdateDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.PODLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('FF') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('FF') && !_vm.multiUpdateDetail.oldfinalPlaceLocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("FF") >= 0 ? "Final Place of Delivery *" : "Final Place of Delivery"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "finalPlaceLocationId", $$v)
      },
      expression: "multiUpdateDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.finalPlaceLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.minusJob.indexOf('FF') >= 0 && _vm.multiUpdateDetail.jobType && !_vm.multiUpdateDetail.jobType.includes('FF') && !_vm.multiUpdateDetail.oldLPlocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("FF") >= 0 ? "Load Port Name *" : "Load Port Name"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Sea_Port_India' :
          'Sea_Port_NonIndia',
          'PortLoadList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Sea_Port_India' :
          'Sea_Port_NonIndia',
          'PortLoadList'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "LPlocationId", $$v)
      },
      expression: "multiUpdateDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.LPlocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.minusJob.indexOf('FF') >= 0 || _vm.minusJob.indexOf('CC') >= 0) && _vm.multiUpdateDetail.jobType && (!_vm.multiUpdateDetail.jobType.includes('FF') || !_vm.multiUpdateDetail.jobType.includes('CC')) && !_vm.multiUpdateDetail.oldPORlocationId) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.minusJob.indexOf("FF") >= 0 ? "Place of Receipt *" : "Place of Receipt"))]), _vm._v("\n          " + _vm._s(_vm.multiUpdateDetail.PORlocationId) + "\n          "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Icd,Sea_Port_India' :
          'Sea_Port_NonIndia',
          'IcdPOrtList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.multiUpdateDetail.shipmentType == '1' &&
          _vm.multiUpdateDetail.transportType == 'Export' ?
          'Icd,Sea_Port_India' :
          'Sea_Port_NonIndia',
          'IcdPOrtList'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "PORlocationId", $$v)
      },
      expression: "multiUpdateDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.PORlocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isErrorsEmpty) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h6', [_vm._v("Error Details")]), _vm._v(" "), _c('ul', _vm._l((_vm.multiUpdateDetailErrors), function(message, field) {
    return _c('li', {
      key: field,
      staticClass: "error"
    }, [_c('strong', [_vm._v(_vm._s(field) + ":")]), _vm._v(" " + _vm._s(message) + "\n            ")])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [(_vm.minusJob.length > 0) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.minusJob.length <= 0
    },
    on: {
      "click": _vm.updateEnquiryMultiUpdate
    }
  }, [_vm._v("\n            Update\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideEnquiryMultiUpdate
    }
  }, [_vm._v("\n            Cancel\n          ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "MultiUpdate-modal",
    attrs: {
      "id": "MultiUpdate-modal",
      "title": ("Change Stuffing and Container - Enq No - " + _vm.mu_enq_series + " Job Type - (" + (_vm.multiUpdateDetail.jobType) + ")"),
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingLocationId"
    }
  }, [_vm._v("Container Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.AutoContainerType),
      callback: function($$v) {
        _vm.AutoContainerType = $$v
      },
      expression: "AutoContainerType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingLocationId"
    }
  }, [_vm._v("To "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location "
    },
    model: {
      value: (_vm.multiUpdateDetail.stuffingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "stuffingLocationId", $$v)
      },
      expression: "multiUpdateDetail.stuffingLocationId"
    }
  })], 1), _vm._v(" "), (_vm.multiUpdateDetail.multipleContainerType && _vm.multiUpdateDetail.multipleContainerType.length > 0) ? _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12"
    }
  }, _vm._l((_vm.multiUpdateDetail.multipleContainerType), function(type, index) {
    return _c('md-chip', {
      key: index,
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "md-deletable": ""
      },
      on: {
        "delete": function($event) {
          _vm.deleteContainer(type)
        }
      }
    }, [_vm._v(_vm._s(type))])
  })) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.updateMultiUpdate
    }
  }, [_vm._v("\n            Update\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideMultiUpdate
    }
  }, [_vm._v("\n            Cancel\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22035596","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewMainEnquiryDetails.vue
// module id = 2459
// module chunks = 0